import {Component, inject, computed, output} from '@angular/core';
import {SidenavService} from '@app-layout/sidenav/data-access';
import {VersionService} from '@cron/data-access';
import {AppInfoStore} from '@cron/data-access';
import {DeviceConditionDirective} from '@shared/device';
import {TooltipModule} from 'primeng/tooltip';
import {CdkCopyToClipboard} from '@angular/cdk/clipboard';
import {ToastService} from '@utils';
import {IconComponent} from '@shared/icon';

@Component({
	selector: 'dc-sidenav-version-info',
	imports: [DeviceConditionDirective, TooltipModule, CdkCopyToClipboard, IconComponent],
	templateUrl: './sidenav-version-info.component.html',
	styleUrls: ['./sidenav-version-info.component.scss'],
})
export class SidenavVersionInfoComponent {
	readonly versionInfoClick = output<void>();
	readonly changelogClick = output<void>();

	protected readonly versionService = inject(VersionService);
	protected readonly appInfoStore = inject(AppInfoStore);
	protected readonly sidenavService = inject(SidenavService);
	protected readonly toastService: ToastService = inject(ToastService);

	protected readonly versionInfo = computed(() => this.versionService.getLocalFrontendVersion());
	protected readonly isCollapsed = computed(() => this.sidenavService.collapsed());
}
